module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAl0lEQVQokWPUbf3PgA8I7fL6/85tGyMu+UtVDAxMeE0gEowaQiNDWLAJCu3yymVgYOhnYGBghvL/MzAw/GVgYCh657ZtElEueee2bTIDA0MgAzP7l58KEQwMzOxfGBgYArEZgNMQqEGbGf7+tGV/sOIkw9+ftu/ctm0myTtIBl1gYGCwwKcGr0tIAVQxhNHe3hN/DiQCAADfWijptocBCgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/09c.png
// module id = 4Rda
// module chunks = 64